/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OnPageRequestBlockingQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type OnPageRequestBlockingQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly onPageRequestsBlockingMode: GraphQL.OnPageRequestsBlockingMode, readonly onPageRequestsBlockingRules: ReadonlyArray<{ readonly __typename?: 'OnPageRequestsBlockingRule', readonly value: string, readonly operator: GraphQL.OnPageRequestsBlockingRuleOperator }> } | null };


export const OnPageRequestBlockingDocument = gql`
    query OnPageRequestBlocking($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    onPageRequestsBlockingMode
    onPageRequestsBlockingRules {
      value
      operator
    }
  }
}
    `;

/**
 * __useOnPageRequestBlockingQuery__
 *
 * To run a query within a React component, call `useOnPageRequestBlockingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnPageRequestBlockingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPageRequestBlockingQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useOnPageRequestBlockingQuery(baseOptions: Apollo.QueryHookOptions<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables> & ({ variables: OnPageRequestBlockingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables>(OnPageRequestBlockingDocument, options);
      }
export function useOnPageRequestBlockingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables>(OnPageRequestBlockingDocument, options);
        }
export function useOnPageRequestBlockingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables>(OnPageRequestBlockingDocument, options);
        }
export type OnPageRequestBlockingQueryHookResult = ReturnType<typeof useOnPageRequestBlockingQuery>;
export type OnPageRequestBlockingLazyQueryHookResult = ReturnType<typeof useOnPageRequestBlockingLazyQuery>;
export type OnPageRequestBlockingSuspenseQueryHookResult = ReturnType<typeof useOnPageRequestBlockingSuspenseQuery>;
export type OnPageRequestBlockingQueryResult = Apollo.QueryResult<OnPageRequestBlockingQuery, OnPageRequestBlockingQueryVariables>;